export default __webpack_public_path__ + "static/media/AdvisorInsights_2023.8f33a437.svg";